import type { DiTypes } from "@iot-platform/core";

export const farmTypes = Object.seal({
    repositories: {
        FarmRepository: Symbol.for("FarmRepository"),
    },
} satisfies DiTypes);
